<template>
  <div>
    <b-form @submit.prevent="submit">
      <validation-summary :errors="errors"></validation-summary>
      <div class="row">
        <v-form-group :validator="$v.labcorp.dateCollected"
                      label="Date Collected"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <date-picker :disabled="onlyView"
                       v-model="labcorp.dateCollected"
                       slot-scope="{ attrs, listeners }"
                       placeholder="Date Collected"
                       v-bind="attrs"
                       v-on="listeners" />
        </v-form-group>
        <v-form-group :validator="$v.labcorp.dateReceived"
                      label="Date Received"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <date-picker :disabled="onlyView"
                       v-model="labcorp.dateReceived"
                       slot-scope="{ attrs, listeners }"
                       v-bind="attrs"
                       v-on="listeners"
                       placeholder="Date Received" />
        </v-form-group>
        <v-form-group :validator="$v.labcorp.dateReported"
                      label="Date Reported"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <date-picker :disabled="onlyView"
                       v-model="labcorp.dateReported"
                       slot-scope="{ attrs, listeners }"
                       v-bind="attrs"
                       v-on="listeners"
                       placeholder="Date Reported" />
        </v-form-group>

        <v-form-group :validator="$v.labcorp.cholesterol"
                      label="Cholesterol"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <b-form-input :disabled="onlyView"
                        type="number"
                        slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="labcorp.cholesterol"
                        placeholder="Cholesterol"
                        min=20
                        max=1000 />
        </v-form-group>

        <v-form-group :validator="$v.labcorp.triglycerides"
                      label="Triglycerides"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <b-form-input :disabled="onlyView"
                        type="number"
                        slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="labcorp.triglycerides"
                        placeholder="Triglycerides"
                        min=5
                        max=10000 />
        </v-form-group>

        <v-form-group :validator="$v.labcorp.hdlc"
                      label="HDL-C"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <b-form-input :disabled="onlyView"
                        type="number"
                        slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="labcorp.hdlc"
                        placeholder="HDL-C"
                        min=20
                        max=150 />
        </v-form-group>

        <v-form-group :validator="$v.labcorp.nonHDLCholesterol"
                      label="Non-HDL Cholesterol"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <b-form-input :disabled="onlyView"
                        type="number"
                        slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="labcorp.nonHDLCholesterol"
                        placeholder="Non-HDL Cholesterol"
                        min=0
                        max=1500 />
        </v-form-group>

        <v-form-group :validator="$v.labcorp.ldlc"
                      label="LDL-C"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <b-form-input :disabled="onlyView"
                        type="number"
                        slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="labcorp.ldlc"
                        placeholder="LDL-C"
                        min=0
                        max=1300 />
        </v-form-group>

        <v-form-group :validator="$v.labcorp.apoB"
                      label="Apo B"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <b-form-input :disabled="onlyView"
                        type="number"
                        slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="labcorp.apoB"
                        placeholder="Apo B"
                        min=0
                        max=400 />
        </v-form-group>

        <v-form-group :validator="$v.labcorp.largeVLDLP"
                      label="Large VLDL-P"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <b-form-input :disabled="onlyView"
                        step=0.01
                        type="number"
                        slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="labcorp.largeVLDLP"
                        placeholder="Large VLDL-P"
                        min=0
                        max=2000 />
        </v-form-group>

        <v-form-group :validator="$v.labcorp.smallLDLP"
                      label="Small LDL-P"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <b-form-input :disabled="onlyView"
                        type="number"
                        slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="labcorp.smallLDLP"
                        placeholder="Small LDL-P"
                        min=0
                        max=2800 />
        </v-form-group>

        <v-form-group :validator="$v.labcorp.hdlp"
                      label="Large HDL-P"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <b-form-input :disabled="onlyView"
                        type="number"
                        step=0.01
                        slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="labcorp.hdlp"
                        placeholder="HDL-P"
                        min=0.1
                        max=99.9 />
        </v-form-group>

        <v-form-group :validator="$v.labcorp.sizeVLDL"
                      label="VLDL Size"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <b-form-input :disabled="onlyView"
                        type="number"
                        step=0.01
                        slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="labcorp.sizeVLDL"
                        placeholder="VLDL Size"
                        min=0
                        max=2000 />
        </v-form-group>

        <v-form-group :validator="$v.labcorp.sizeLDL"
                      label="LDL Size"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <b-form-input :disabled="onlyView"
                        type="number"
                        step=0.01
                        slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="labcorp.sizeLDL"
                        placeholder="LDL Size"
                        min=18
                        max=30 />
        </v-form-group>

        <v-form-group :validator="$v.labcorp.sizeHDL"
                      label="HDL Size"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <b-form-input :disabled="onlyView"
                        type="number"
                        step=0.01
                        slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="labcorp.sizeHDL"
                        placeholder="HDL Size"
                        min=0
                        max=2000 />
        </v-form-group>

        <v-form-group :validator="$v.labcorp.insulinResistance"
                      label="Score LP-IR"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <b-form-input :disabled="onlyView"
                        type="number"
                        slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="labcorp.insulinResistance"
                        placeholder="Score LP-IR"
                        min=20
                        max=100 />
        </v-form-group>

        <v-form-group v-if="isNotRepeatedCraPob"
                      :validator="$v.labcorp.platelets"
                      label="Platelets"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <b-form-input :disabled="onlyView"
                        type="number"
                        slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="labcorp.platelets"
                        placeholder="Platelets"
                        min="0"
                        max="4000" />
        </v-form-group>

        <v-form-group :validator="$v.labcorp.glucose"
                      label="Fasting Glucose"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <b-form-input :disabled="onlyView"
                        type="number"
                        slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="labcorp.glucose"
                        placeholder="Fasting Glucose"
                        min=30
                        max=800 />
        </v-form-group>

        <v-form-group :validator="$v.labcorp.bun"
                      label="BUN"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <b-form-input :disabled="onlyView"
                        type="number"
                        slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="labcorp.bun"
                        placeholder="BUN"
                        min=1
                        max=150 />
        </v-form-group>

        <v-form-group :validator="$v.labcorp.creatinine"
                      label="Creatinine"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <b-form-input :disabled="onlyView"
                        type="number"
                        step=0.01
                        slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="labcorp.creatinine"
                        placeholder="Creatinine"
                        min=0.1
                        max=20 />
        </v-form-group>

        <v-form-group :validator="$v.labcorp.egfr"
                      label="eGFR"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <b-form-input :disabled="onlyView"
                        type="number"
                        slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="labcorp.egfr"
                        placeholder="eGFR"
                        min=1
                        max=140 />
        </v-form-group>

        <v-form-group :validator="$v.labcorp.bunCreatinineRatio"
                      label="BUN/Creatinine Ratio"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <b-form-input :disabled="onlyView"
                        type="number"
                        slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="labcorp.bunCreatinineRatio"
                        placeholder="BUN/Creatinine Ratio"
                        min=1
                        max=100 />
        </v-form-group>

        <v-form-group :validator="$v.labcorp.sodium"
                      label="Sodium"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <b-form-input :disabled="onlyView"
                        type="number"
                        slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="labcorp.sodium"
                        placeholder="Sodium"
                        min=90
                        max=220 />
        </v-form-group>

        <v-form-group :validator="$v.labcorp.potassium"
                      label="Potassium"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <b-form-input :disabled="onlyView"
                        type="number"
                        step=0.01
                        slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="labcorp.potassium"
                        placeholder="Potassium"
                        min=1.0
                        max=10 />
        </v-form-group>

        <v-form-group :validator="$v.labcorp.chloride"
                      label="Chloride"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <b-form-input :disabled="onlyView"
                        type="number"
                        slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="labcorp.chloride"
                        placeholder="Chloride"
                        min=50
                        max=140 />
        </v-form-group>

        <v-form-group :validator="$v.labcorp.carbonDioxide"
                      label="Carbon Dioxide"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <b-form-input :disabled="onlyView"
                        type="number"
                        slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="labcorp.carbonDioxide"
                        placeholder="Carbon Dioxide"
                        min=3
                        max=60 />
        </v-form-group>

        <v-form-group :validator="$v.labcorp.calcium"
                      label="Calcium"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <b-form-input :disabled="onlyView"
                        type="number"
                        step=0.01
                        slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="labcorp.calcium"
                        placeholder="Calcium"
                        min=3.0
                        max=25 />
        </v-form-group>

        <v-form-group v-if="isNotRepeatedCraPob" 
                      :validator="$v.labcorp.proteinTotal"
                      label="Protein, Total"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <b-form-input :disabled="onlyView"
                        type="number"
                        step="0.1"
                        slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="labcorp.proteinTotal"
                        placeholder="Protein, Total"
                        min="0"
                        max="20.0" />
        </v-form-group>

        <v-form-group v-if="isNotRepeatedCraPob"
                      :validator="$v.labcorp.albumin"
                      label="Albumin"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <b-form-input :disabled="onlyView"
                        type="number"
                        step="0.1"
                        slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="labcorp.albumin"
                        placeholder="Albumin"
                        min="0"
                        max="20.0" />
        </v-form-group>

        <v-form-group v-if="isNotRepeatedCraPob"
                      :validator="$v.labcorp.bilirubinTotal"
                      label="Bilirubin, Total"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <b-form-input :disabled="onlyView"
                        type="number"
                        step="0.1"
                        slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="labcorp.bilirubinTotal"
                        placeholder="Bilirubin, Total"
                        min="0"
                        max="10.0" />
        </v-form-group>

        <v-form-group v-if="isNotRepeatedCraPob"
                      :validator="$v.labcorp.alkalinePhosphatase"
                      label="Alkaline Phosphatase"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <b-form-input :disabled="onlyView"
                        type="number"
                        slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="labcorp.alkalinePhosphatase"
                        placeholder="Alkaline Phosphatase"
                        min="0"
                        max="500" />
        </v-form-group>

        <v-form-group v-if="isNotRepeatedCraPob"
                      :validator="$v.labcorp.ast"
                      label="AST"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <b-form-input :disabled="onlyView"
                        type="number"
                        slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="labcorp.ast"
                        placeholder="AST"
                        min="0"
                        max="500" />
        </v-form-group>

        <v-form-group v-if="isNotRepeatedCraPob"
                      :validator="$v.labcorp.alt"
                      label="ALT"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <b-form-input :disabled="onlyView"
                        type="number"
                        slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="labcorp.alt"
                        placeholder="ALT"
                        min="0"
                        max="5000" />
        </v-form-group>

        <v-form-group v-if="report.typeId !== ProductType.CondensedRepeatedCRAAPOB"
                      :validator="$v.labcorp.a1C"
                      label="A1C"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <b-form-input :disabled="onlyView"
                        type="number"
                        step=0.1
                        slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="labcorp.a1C"
                        placeholder="A1C"
                        min=1
                        max=25 />
        </v-form-group>

        <v-form-group v-if="report.typeId !== ProductType.CondensedRepeatedCRAAPOB"
                      :validator="$v.labcorp.lpa"
                      label="Lp(a)"
                      class="col-12 col-md-6 col-lg-6 col-xl-3">
          <b-form-input :disabled="onlyView"
                        type="number"
                        slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="labcorp.lpa"
                        placeholder="Lp(a)"
                        min="0"
                        max="600"
                        step="0.1" />
        </v-form-group>

        <v-form-group v-if="report.typeId !== ProductType.CondensedRepeatedCRAAPOB"
                      class="col-12 col-md-6 col-lg-6 col-xl-1">
          <b-form-select :disabled="onlyView"
                         slot-scope="{ attrs, listeners }"
                         v-bind="attrs"
                         v-on="listeners"
                         v-model="labcorp.lpaUnit"
                         :options="lpaUnitOptions" />
        </v-form-group>
        

        <v-form-group v-if="report.typeId !== ProductType.CondensedRepeatedCRAAPOB"
                      label="TSH"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <b-form-input :disabled="onlyView"
                        type="number"
                        slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="labcorp.tsh"
                        placeholder="TSH"
                        step="0.001"
                        min=0 />
        </v-form-group>

        <v-form-group v-if="report.typeId !== ProductType.CondensedRepeatedCRAAPOB"
                      :validator="$v.labcorp.glycA"
                      label="Glyc A"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <b-form-input :disabled="onlyView"
                        type="number"
                        slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="labcorp.glycA"
                        placeholder="Glyc A"
                        min=0
                        max=800 />
        </v-form-group>

        <v-form-group label="uACR"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <b-form-input :disabled="onlyView"
                        type="number"
                        slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="labcorp.uACR"
                        placeholder="uACR"
                        min="0"
                        max="9999"
                        step="1" />
        </v-form-group>

        <v-form-group label="Patient Id"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <b-form-input :disabled="onlyView"
                        slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="labcorp.mrn"
                        placeholder="Patient Id" />
        </v-form-group>
      </div>
      <b-form-group class="form-buttons">
        <b-btn variant="success" type="submit" :disabled="onlyView">Generate Final Report</b-btn>
      </b-form-group>
    </b-form>
  </div>
</template>

<script>
  import { required, between, requiredIf } from "vuelidate/lib/validators";
  import formMixin from 'mixins/form-mixin';
  import finalReportFormMixin from 'mixins/final-report-form-mixin';
  import ProductType from '@/enums/product-type';
  import LpaUnit from 'enums/lpa-type';

  export default {
    mixins: [formMixin, finalReportFormMixin],

    data() {
      return {
        ProductType,
        lpaUnitOptions: [
          { value: LpaUnit.NmolL, text: 'nmol/L' },
          { value: LpaUnit.MgDl, text: 'mg/dL' }
        ]
      };
    },

    computed: {
      isNotRepeatedCraPob() {
        return this.report.typeId !== ProductType.CondensedRepeatedCRAAPOB;
      },
    },

    validations: {
      labcorp: {
        dateCollected: { required },
        dateReceived: { required },
        dateReported: { required },
        cholesterol: { required, between: between(20, 1000) },
        triglycerides: { required, between: between(5, 10000) },
        hdlc: { required, between: between(20, 150) },
        nonHDLCholesterol: { required, between: between(0, 1500) },
        ldlc: { required, between: between(0, 1300) },
        apoB: { required, between: between(0, 400) },
        largeVLDLP: { required, between: between(0, 2000) },
        smallLDLP: { required, between: between(0, 2800) },
        hdlp: { required, between: between(0, 100) },
        sizeVLDL: { required, between: between(0, 2000) },
        sizeLDL: { required, between: between(18, 30) },
        sizeHDL: { required, between: between(0, 2000) },
        insulinResistance: { required, between: between(20, 100) },
        lpa: { required: requiredIf(function () { return this.report.type.startsWith("Cardiometabolic") && this.report.typeId !== ProductType.CondensedRepeatedCRAAPOB }), between: between(0, 600) },
        glycA: { required: requiredIf(function () { return this.report.typeId !== ProductType.CondensedRepeatedCRAAPOB }), between: between(0, 800) },
        glucose: { required, between: between(30, 800) },
        bun: { between: between(1, 150) },
        creatinine: { between: between(0, 20) },
        egfr: { required, between: between(1, 140) },
        bunCreatinineRatio: { between: between(1, 100) },
        sodium: { between: between(90, 220) },
        potassium: { between: between(1, 10) },
        chloride: { between: between(50, 140) },
        carbonDioxide: { between: between(3, 60) },
        calcium: { between: between(3, 25) },
        a1C: { between: between(3, 15) },
        platelets: { between: between(0, 4000) },
        proteinTotal: { between: between(0, 20.0) },
        albumin: { between: between(0, 20.0) },
        bilirubinTotal: { between: between(0, 10.0) },
        alkalinePhosphatase: { between: between(0, 500) },
        ast: { between: between(0, 500) },
        alt: { between: between(0, 5000) },        
      }
    }
  };
</script>